import {getMethod, patchMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownCarRentContracts', request)
}

async function post(request) {
    return await postMethod('/api/ownCarRentContracts', request)
}

async function put(request) {
    return await putMethod('/api/ownCarRentContracts', request)
}

async function patch(id, request) {
    return await patchMethod(`/api/ownCarRentContracts/${id}`, request)
}

export {get, post, put, patch}
